import { render, staticRenderFns } from "./orderProductionPanelPopover.vue?vue&type=template&id=23d6d49a&scoped=true&"
import script from "./orderProductionPanelPopover.vue?vue&type=script&lang=js&"
export * from "./orderProductionPanelPopover.vue?vue&type=script&lang=js&"
import style0 from "./orderProductionPanelPopover.vue?vue&type=style&index=0&id=23d6d49a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6d49a",
  null
  
)

export default component.exports